import { useQuery } from '@tanstack/react-query';
import { getAdherenceService } from '../../../domains/adherence';

type PrescriptionType = 'long' | 'short' | undefined;

/**
 * 환자 복약 상세 조회 (`/pharm-dashboard/dosage/detail?user_id=&type=`).
 * adherence/patient/posModal에서 공유.
 *
 * type='long'|'short' 지정 시 해당 처방 종류만 받음. 미지정 시 전체.
 */
export const usePatientDetail = (
  userId: number | string | null | undefined,
  type: PrescriptionType = undefined,
) => {
  return useQuery({
    queryKey: ['patient-detail', userId, type ?? null],
    enabled: userId != null && userId !== '',
    queryFn: async () => {
      const res = await getAdherenceService().getPatientDetail(userId, type);
      return res?.data?.data ?? res?.data ?? null;
    },
  });
};
